module.exports = __webpack_public_path__ + "img/process-trends-example@2x.3ea4964f.png";